import * as React from 'react'
import BasicImage from '../FacetedCarousel/Card/Packshot/BasicImage'
import * as csm from '../../../utils/csm'
import * as style from './HeroElement.module.scss'
import * as playerStyles from './PlayerHover.module.scss'
import * as cn from 'classnames'
import PlayerHover from './PlayerHover'
import DraperPlayer from '../../../../../DVWebNodeDraperPlayer/DraperPlayer'
import { DraperPlayerPlacement } from '../../../../../DVWebNodeDraperPlayer/types'
import checkUrlType from '../../../utils/url-type-checker'
import { StorefrontItem } from 'DVWebNodeUtils';
import { VideoContext } from '../../../../../DVWebNodeDraperPlayer/videoContext'
import { FeatureSwitches } from 'widgets/Explore/DVWebNodeStorefront/shared/containers/Storefront'

const BASELINE_SIZE = 1500

interface HeroElementProps {
  index?: number
  hasDraperPlayer?: boolean
  item: StorefrontItem
  autoScrollFunc?: () => void
  autoScrollDelayMilli?: number
  isActive?: boolean
  loadNow?: boolean
  formFactor: string
  featureSwitches?: FeatureSwitches
}

interface HeroElementState {
  playerVisibilityStyle: string
}

export class HeroElement extends React.PureComponent<HeroElementProps, HeroElementState> {
  index?: number
  state: HeroElementState
  dvWebClientImgLoadFailure: Function

  components: {
    playerHoverComponent?: PlayerHover
    draperPlayerComponent?: DraperPlayer
  } = {}

  constructor(props: HeroElementProps) {
    super(props)
    this.index = props.index
    this.dvWebClientImgLoadFailure = () => {
      csm.count('dvWebClientImgLoadFailure')
    }

    this.state = {
      playerVisibilityStyle: playerStyles.imageUnBlur
    }
  }

  setImageVisibility(visible: boolean) {
    this.setState({
      playerVisibilityStyle: visible ? playerStyles.imageUnBlur : playerStyles.imageBlur
    })
  }

  render() {
    return (
      <div data-index={this.props.index}
        tabIndex={0}
        className={cn(style.content, style.imageWrapper, this.state.playerVisibilityStyle, 'tst-hero-element')}
      >
        <a
          href={checkUrlType(this.props.item.link.url, 'HeroElement')}
          title={this.props.item.link.label || this.props.item.title}>
          <BasicImage
            alternateText={this.props.item.image.alternateText || this.props.item.title}
            url={this.props.item.image.url} onError={() => this.dvWebClientImgLoadFailure()}
            defaultWidth={BASELINE_SIZE}
            loading={"eager"}
            legacy={this.props.featureSwitches.isIEorLegacyEdge}
          />
        </a>
        {Boolean(this.props.hasDraperPlayer) && <PlayerHover
          key={(this.props.item.link && this.props.item.link.url) || this.index}
          ref={(component) => {
            this.components.playerHoverComponent = component
          }}
          item={this.props.item}
          setImageVisibility={(visible: boolean) => this.setImageVisibility(visible)}
          draperPlayerComponent={this.components.draperPlayerComponent}
          formFactor={this.props.formFactor}
        >
          <VideoContext.Consumer>
            {(context) => 
              <DraperPlayer
                prerolls={this.props.item.prerolls}
                link={this.props.item.link ? this.props.item.link.url : undefined}
                placement={DraperPlayerPlacement.Superhero}
                ref={(component) => {
                  this.components.draperPlayerComponent = component
                }}
                videoContext={context}
                playerIsActive={false}
                enableFullscreen={false}
                parentListeners={{
                  onPlayStart: () => {
                    if(this.components.playerHoverComponent) {
                      this.components.playerHoverComponent.playerVisible(true)
                      this.components.playerHoverComponent.toggleOverlay(true)
                    }
                  },
                  onPlayStop: () => {
                    if(this.components.playerHoverComponent) {
                      this.components.playerHoverComponent.playerVisible(false)
                      this.components.playerHoverComponent.toggleOverlay(false)
                    }        
                  },
                  onPlayComplete: () => {
                    if (this.props.isActive) {
                      this.props.autoScrollFunc()
                    }
                  }
                }} />
            }
          </VideoContext.Consumer>
        </PlayerHover>}
      </div>
    )
  }
}
